module.exports = __webpack_public_path__ + "img/bubble-right.6ae34d53.svg";